import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  AllCollectionPointDetails,
  AddCollectionPointsDetails,
  UpdateCollectionPointsDetails,
} from "../../Apis/collectionPointsApi";
import { AllCollectionPointsCategoryDetails } from "../../Apis/collectionPointsCategoryApi";
import {
  GetZone,
  GetWard,
  GetCircle,
  GetCirclebyID,
  GetWardsbyCircleId,
} from "../../Apis/organizationApi";
import TableComponent from "../../Common/TableComponent/tableComponent";
import { withTranslation } from "react-i18next";
const CollectionType = ({t}) => {
  const headers = [ "collectionTypeName",  "actions"];
  const [lgShow, setLgShow] = useState(false);
  const [fetchDataLoaded, setFetchDataLoaded] = useState(false);
  const [collectionPointDetails, setCollectionPointDetails] = useState([]);
  const [collectionDetails, setCollectionDetails] = useState([]);
  const [collectionPointCategoryDetails, setCollectionPointCategoryDetails] =
    useState([]);
  const [allZones, setAllZones] = useState([]);
  const [allCircles, setAllCircles] = useState([]);
  const [allWards, setAllWards] = useState([]);
  const [noWardsUnderCircle, setNoWardsUnderCircle] = useState(false);
  const [circleFetchError, setCircleFetchError] = useState(null);
  const [editCollectionDetails, setEditCollectionDetails] = useState("");
  const [loadingCircles, setLoadingCircles] = useState(false);
  const [selectedWard, setSelectedWard] = useState(
    editCollectionDetails ? editCollectionDetails.wardId : ""
  );
  const [selectedZone, setSelectedZone] = useState("");
  const [selectedCircles, setSelectedCircles] = useState([]);
  const [tableKey, setTableKey] = useState(0);
  const [shiftData, setShiftData] = useState([]);
  const [noCircles, setNoCircles] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formInput, setFormInput] = useState({
    collectionPointType: "",
    zoneId: "",
    circleId: "",
    wardId: "",
    collectionPointName: "",
    latitude: "",
    longitude: "",
    shiftIds: "",
    collectionPointCode: "",
    landmark: "",
  });
 
  const handleClose = async () => {
    setFormInput({
      collectionPointType: "",
      zoneId: "",
      circleId: "",
      wardId: "",
      collectionPointName: "",
      latitude: "",
      longitude: "",
      shiftIds: "",
 
      collectionPointCode: "",
      landmark: "",
    });
    setEditCollectionDetails(null);
    setLgShow(false);
 
    // setAllZones([]);
    setAllCircles([]);
    setAllWards([]);
  };
 
  const handleShow = () => {
    setLgShow(true);
    setFormInput({
      collectionPointType: "",
      zoneId: "",
      circleId: "",
      wardId: "",
      collectionPointName: "",
      latitude: "",
      longitude: "",
      shiftIds: "",
 
      collectionPointCode: "",
      landmark: "",
    });
    setEditCollectionDetails(null);
  };
 
  const handleEditCollectionDetails = (selectedData) => {
    setEditCollectionDetails(selectedData);
    // Set form input values
    setFormInput({
      collectionPointId: selectedData.collectionPointId,
      collectionPointType: selectedData.collectionPointType,
      zoneId: selectedData.zoneId,
      circleId: selectedData.circleId,
      wardId: selectedData.wardId,
      collectionPointName: selectedData.collectionPointName,
      latitude: selectedData.latitude,
      longitude: selectedData.longitude,
      shiftIds: selectedData.shiftIds,
      collectionPointCode: selectedData.collectionPointCode,
      landmark: selectedData.landmark, // Make sure to include this li
    });
 
    // Fetch circles for the selected zone
    fetchCirclesData(selectedData.zoneId)
      .then(() => {
        // Once circles are fetched, fetch wards for the selected circle
        fetchWardsData(selectedData.zoneId, selectedData.circleId);
      })
      .catch((error) => {
        console.error("Error fetching circles and wards:", error);
      });
 
    setLgShow(true);
  };
 
  const handleInputChange = (e) => {
    const { name, value } = e.target;
 
    let sanitizedValue = value;
 
    // Handle wardId separately
    if (name === "wardId") {
      // You might want to add additional validation or sanitization for wardId
      // For example, ensure it's a valid number or any specific constraints
 
      // For now, let's assume wardId should be a positive integer
      const intValue = parseInt(value, 10);
      if (!isNaN(intValue) && intValue > 0) {
        sanitizedValue = intValue.toString();
      } else {
        // Invalid input, handle accordingly (you can show an error message, etc.)
        return;
      }
    } else if (name === "landmark") {
      // Allow alphabetical characters and spaces
      sanitizedValue = value
        .slice(0, 100)
        .replace(/[^A-Za-z\s]/g, "")
        .toUpperCase();
    }
 
    // You can add additional conditions for other fields if needed
 
    setFormInput((prevData) => ({
      ...prevData,
      [name]: sanitizedValue,
    }));
  };
 
  const handleCircleChange = async (circleId) => {
    setFormInput((prevData) => ({
      ...prevData,
      circleId: circleId,
      wardId: "", // Reset ward when circle changes
    }));
 
    try {
      // Fetch wards for the selected circle
      const wardsData = await GetWardsbyCircleId(circleId);
      setAllWards(wardsData);
    } catch (error) {
      console.error("Error fetching wards data:", error);
      // Handle error if needed...
    }
  };
 
  const handleCreateCollectionPointDetails = async (e) => {
    e.preventDefault();
 
    try {
      setIsLoading(true);
      if (editCollectionDetails) {
        const updatedCollectionPointDetailsData = { ...formInput };
        const response = await UpdateCollectionPointsDetails(
          updatedCollectionPointDetailsData
        );
        setCollectionPointDetails([...collectionPointDetails, response]);
        toast.success("Collection Points updated successfully");
        handleClose();
       fetchAllCollectionPointDetails()
      } else {
        const response = await AddCollectionPointsDetails(formInput);
        setCollectionPointDetails([...collectionPointDetails, response]);
        toast.success("Collection Points added successfully");
       fetchAllCollectionPointDetails()
      }
      handleClose();
    } catch (error) {
      // Handle form submission error, including validation errors
      if (error.response && error.response.status === 400) {
        // Backend returned validation errors
        const validationErrors = error.response.data.errors;
        // Iterate through validation errors and show corresponding toast notifications
        for (const field in validationErrors) {
          toast.error(`${validationErrors[field][0]}`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        }
      }
    } finally {
      setIsLoading(false);
    }
    // handleClose()
  };
 
  useEffect(() => {
    if (formInput.circleId) {
      setLoadingCircles(true);
      // Fetch wards for the selected circle
      fetchWardsData(formInput.zoneId, formInput.circleId);
 
      // Reset ward when circle changes
      setFormInput((prevData) => ({
        ...prevData,
        wardId: formInput.wardId,
      }));
      setSelectedWard("");
    }
 
    // Fetch circles for the selected zone
    if (formInput.zoneId) {
      setLoadingCircles(true);
      fetchCirclesData(formInput.zoneId);
    }
  }, [formInput.circleId, formInput.zoneId]);
 
  const fetchCirclesData = async (zoneId) => {
    try {
      const response = await GetCirclebyID(zoneId);
      setAllCircles(response);
      setNoCircles(response.length === 0);
      setCircleFetchError(null); // Clear error if successful
    } catch (error) {
      console.error("Error fetching circles data:", error);
      setAllCircles([]); // Clear circles data on error
      setNoCircles(true);
      setCircleFetchError(
        error.response ? error.response.data.message : "Unknown error occurred"
      ); // Set error message from the backend or use a default message
      toast.error(`Error fetching circles: ${circleFetchError}`);
      setLoadingCircles(true);
    }
  };
 
  const fetchWardsData = async (zoneId, circleId) => {
    try {
      setIsLoading(true);
      const response = await GetWardsbyCircleId(circleId);
      setAllWards(response);
      setNoWardsUnderCircle(response.data.length === 0);
    } catch (error) {
      console.error("Error fetching wards data:", error);
    } finally {
      setIsLoading(false);
    }
  };
 
  // useEffect(() => {
  //   if (!apiCallsInProgress) {
  //     // Set API calls in progress
  //     setApiCallsInProgress(true);
 
  // Fetch all data only if API calls are not in progress
 
  const fetchData = async () => {
    try {
      setIsLoading(true);
      const collectionPointsData = await AllCollectionPointDetails();
      setCollectionPointDetails(collectionPointsData);
 
      const collectionPointCategoryData =
        await AllCollectionPointsCategoryDetails();
      setCollectionPointCategoryDetails(collectionPointCategoryData);
      setFetchDataLoaded(true);
    } catch (error) {
      console.error("Error fetching initial data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchData(); // Call fetchData when the component mounts
  }, []); // Add selectedZone as a dependency
 
  const fetchAllDataDetails = async () => {
    try {
      setIsLoading(true);
      const zonesData = await GetZone();
      setAllZones(zonesData);
      // Fetch circles only if a zone is selected
      if (selectedZone) {
        setLoadingCircles(true);
        const circlesData = await GetCirclebyID(selectedZone);
        setAllCircles(circlesData);
        setSelectedCircles([]);
        setLoadingCircles(false);
      } else {
        // Reset circles and selected circles if no zone is selected
        setAllCircles([]);
        setSelectedCircles([]);
        setLoadingCircles(false);
      }
      // Fetch more data if needed...
    } catch (error) {
      console.error("Error fetching initial data:", error);
      // Handle error if needed...
    } finally {
      setIsLoading(false);
    }
  };
 
  // fetchData();
 
  // }, []);
 
  useEffect(() => {
    fetchAllDataDetails();
  }, []);

 
  useEffect(() => {
    // Fetch circles only if a zone is selected
    if (selectedZone) {
      const fetchCirclesData = async () => {
        try {
          const circlesData = await GetCirclebyID(selectedZone);
          setAllCircles(circlesData.data);
          setSelectedCircles([]);
        } catch (error) {
          console.error("Error fetching circles data:", error);
        }
      };
 
      fetchCirclesData();
    } else {
      // Reset circles and selected circles if no zone is selected
      setAllCircles([]);
      setSelectedCircles([]);
    }
  }, []);
 
  const fetchCirclesAndWards = async (zoneId) => {
    try {
      // Fetch circles for the selected zone
      const circlesData = await GetCirclebyID(zoneId);
      setAllCircles(circlesData);
      setSelectedCircles([]);
      setCircleFetchError(null);
      setNoCircles(false);
    } catch (error) {
      console.error("Error fetching circles data:", error);
      setCircleFetchError("Error fetching circles data");
      setAllCircles([]);
      setNoCircles(false);
    }
  };
 
  useEffect(() => {
    if (selectedZone) {
      // Clear circles and wards when zone changes
      setAllCircles([]);
      setAllWards([]);
      setSelectedCircles([]);
      setSelectedWard("");
    }
  }, [selectedZone]);
 
  // const handleViewCollectionPoints = async (id) => {
  //   try {
  //     const response = await getCollectionPointsById(id);
  //     const collectionPointDetails = response.data.data;
  //     navigate("/view-collection-points-details", {
  //       state: { collectionPointDetails },
  //     });
  //   } catch (error) {
  //   }
  // };
 
  const fetchAllCollectionPointDetails = async () => {
    const [
      collectionPointDetails,
      wardNameResponse,
      zoneNameResponse,
      circleNameResponse,
    ] = await Promise.all([
      AllCollectionPointDetails(),
      GetWard(),
      GetZone(),
      GetCircle(),
    ]);
 
 
    const collectionPointData = collectionPointDetails.map((station) => {
      const ward = wardNameResponse.find(
        (ward) => ward.wardId === station.wardId
      );
      const zone = zoneNameResponse.find(
        (zone) => zone.zoneId === station.zoneId
      );
      const circle = circleNameResponse.find(
        (circle) => circle.circleId === station.circleId
      );
      return {
        ...station,
        wardName: ward ? ward.wardName : "N/A",
        zoneName: zone ? zone.zoneName : "N/A",
        circleName: circle ? circle.circleName : "N/A",
      };
    });
    setCollectionDetails(collectionPointData)
  };
 
  useEffect(() => {
    fetchAllCollectionPointDetails();
  }, []);
 
  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header">
              <div className="text-end mb-3">
                <button className="button-container" onClick={handleShow}>
                  <i className="fa-solid fa-plus me-1 icon-container"></i>
                  {t("addCollection")}
                </button>
              </div>
            </div>
            <div className="top-header">
              <span>{t("collectionPoints")}</span>
            </div>
            <div className="card">
              <div className="card-body">
                <TableComponent
                  DataFetchURL={collectionDetails}
                  headers={headers}
                  key={tableKey}
                  filterFunction={(data) =>
                    data.filter(
                      (item) => item.status === 1 || item.status === 2
                    )
                  }
                  editData={handleEditCollectionDetails} // Pass the callback function
                  editDataDetails={editCollectionDetails}
                  // viewData={(id) => handleViewCollectionPoints(id)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* {isLoading && <Loader />}
      {!fetchDataLoaded && <Loader />} */}
      <Modal
        size="lg"
        show={lgShow}
        onHide={() => handleClose()}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title>
            {" "}
            {editCollectionDetails ? t("editCollection") : t("addCollection")}
          </Modal.Title>
          <i
            class="fa-solid fa-xmark close-container"
            onClick={handleClose}
          ></i>
        </Modal.Header>
        <hr />
        <Modal.Body>
          <form onSubmit={handleCreateCollectionPointDetails}>
            {/* ... (previous code) */}
            <div className="row">
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    Collection Point Type{" "}
                    <span style={{ color: "#EC1117" }}>*</span>
                  </label>
                  <select
                    value={formInput.collectionPointType}
                    name="collectionPointType"
                    onChange={(e) => {
                      const collection = e.target.value;
                      setFormInput((prevData) => ({
                        ...prevData,
                        collectionPointType: collection,
                      }));
                    }}
                    className="form-select"
                  >
                    <option value="">Select</option>
                    <option value="GVP">GVP</option>
                    <option value="Hotspot">Hotspot</option>
                  </select>
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    Vehicle Allotted Zone{" "}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <select
                    value={formInput.zoneId}
                    name="zoneId"
                    className="form-select"
                    // Inside the <select> element for the zone dropdown
                    onChange={(e) => {
                      const selectedZoneId = e.target.value;
                      setSelectedZone(selectedZoneId);
 
                      // Check if the selected zone is different from the previously selected zone
                      if (selectedZoneId !== selectedZone) {
                        // Fetch circles and wards only if the zone is different
                        fetchCirclesAndWards(selectedZoneId);
                      }
 
                      // Update formInput with the selected zoneId
                      setFormInput({
                        ...formInput,
                        zoneId: selectedZoneId,
                        circleId: "", // Reset circleId when zone changes
                        wardId: "", // Reset wardId when zone changes
                      });
                    }}
                  >
                    <option value="">Select</option>
                    {allZones?.map((zone) => (
                      <option key={zone.zoneId} value={zone.zoneId}>
                        {zone.zoneName}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-4 mb-3">
                {/* {circleFetchError ? (
                  <p className="text-danger">{circleFetchError}</p>
                ) : noCircles ? (
                  <p>No circles under this zone</p>
                ) : ( */}
                <div className="form-group">
                  <label className="form-label">
                    Vehicle Allotted Circle{" "}
                    <span style={{ color: "#EC1117" }}> *</span>{" "}
                  </label>
                  <select
                    value={formInput.circleId}
                    name="circleId"
                    className="form-select"
                    onChange={(e) => {
                      setFormInput((prevData) => ({
                        ...prevData,
                        circleId: e.target.value,
                        wardId: "", // Reset ward when circle changes
                      }));
                      handleCircleChange(e.target.value); // Fetch wards for the selected circle
                    }}
                  >
                    <option value="">Select</option>
                    {/* {loadingCircles && <option>Loading circles...</option>} */}
                    {Array.isArray(allCircles) && allCircles.length > 0 ? (
                      allCircles.map((circle) => (
                        <option key={circle.circleId} value={circle.circleId}>
                          {circle.circleName}
                        </option>
                      ))
                    ) : (
                      <option value="" disabled>
                        No circles found
                      </option>
                    )}
                  </select>
                </div>
                {/* )} */}
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    Vehicle Allotted Ward{" "}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <select
                    value={formInput.wardId}
                    name="wardId"
                    className="form-select"
                    onChange={(e) =>
                      setFormInput((prevData) => ({
                        ...prevData,
                        wardId: e.target.value,
                      }))
                    }
                  >
                    <option value="">Select</option>
                    {Array.isArray(allWards) &&
                      allWards.map((ward) => (
                        <option key={ward.wardId} value={ward.wardId}>
                          {ward.wardName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    Point Name <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    name="collectionPointName"
                    className="form-control"
                    onChange={handleInputChange}
                    value={formInput.collectionPointName}
                  />
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    Latitude <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    name="latitude"
                    className="form-control"
                    onChange={handleInputChange}
                    value={formInput.latitude}
                  />
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    Longitude <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    name="longitude"
                    className="form-control"
                    onChange={handleInputChange}
                    value={formInput.longitude}
                  />
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">Shift Name</label>
                  <select
                    value={formInput.shiftIds}
                    name="shiftIds"
                    className="form-select"
                    onChange={(e) => {
                      const shiftIds = e.target.value;
                      setFormInput((prevData) => ({
                        ...prevData,
                        shiftIds: shiftIds,
                      }));
                    }}
                  >
                    <option value="">Select</option>
                    {Array.isArray(shiftData) &&
                      shiftData.map((shift) => (
                        <option key={shift.shiftIds} value={shift.shiftIds}>
                          {shift.shiftName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    Collection Point Code{" "}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    name="collectionPointCode"
                    className="form-control"
                    onChange={handleInputChange}
                    value={formInput.collectionPointCode}
                  />
                </div>
              </div>
              {/* <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    LandMark <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    name="landmark"
                    className="form-control"
                    onChange={handleInputChange}
                    value={formInput.landmark}
                  />
                </div>
              </div> */}
              {/* <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">Pickup Times</label>
                  <input
                    type="text"
                    name="pickup_times"
                    className="form-control"
                    onChange={handleInputChange}
                    value={formInput.pickup_times}
                  />
                </div>
              </div>
              <div className="col-md-4" style={{ marginTop: "5px" }}>
                <label className="form-label">
                  {t("status")}
                  <span style={{ color: "#EC1117" }}> *</span>
                </label>
                <div className="form-group" style={{ display: "flex" }}>
                  <div className="form-check">
                    <input
                      type="radio"
                      className="form-check-input"
                      name="status"
                      id="activeRadio"
                      checked={parseInt(formInput.status, 10) === 1}
                      onChange={() =>
                        handleInputChange({
                          target: { name: "status", value: 1 },
                        })
                      }
                    />
                    <label className="form-check-label" htmlFor="activeRadio">
                      Active
                    </label>
                  </div>
                  <div className="form-check" style={{ marginLeft: "40px" }}>
                    <input
                      type="radio"
                      className="form-check-input"
                      name="status"
                      id="inactiveRadio"
                      checked={parseInt(formInput.status, 10) === 0}
                      onChange={() =>
                        handleInputChange({
                          target: { name: "status", value: 0 },
                        })
                      }
                    />
                    <label className="form-check-label" htmlFor="inactiveRadio">
                      Inactive
                    </label>
                  </div>
                </div>
              </div> */}
            </div>
 
            <div className="modal-footer d-flex justify-content-center">
              <button type="submit" className="deployment-button">
                <i class="fa-solid fa-check done-container"></i>
                {editCollectionDetails
                  ? t("updateCollection")
                  : t("addCollection")}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};
 
export default withTranslation()(CollectionType);